
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedFullRight as ObiSpeedFullRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-full-right.js';
 
 
 

 
 export const ObiSpeedFullRight = createComponent({
   react: React,
   tagName: 'obi-speed-full-right',
   elementClass: ObiSpeedFullRightElement,
   events: {
     
   }
  });
 
 